t = require('app/scripts/views/internal/teacup-with-helpers')('select_org_to_upgrade')
localizeCount = require 'app/scripts/lib/localize-count'

module.exports = ->
  t.div '.select-org-to-upgrade', ->

    t.h2 '.select-org-to-upgrade-header', ->
      t.format 'select-an-organization-to-upgrade-to-business-class'

    t.ul '.select-org-to-upgrade-list', ->
      t.mustacheBlock 'orgs', ->
        t.li '.select-org-to-upgrade-list-item', ->
          t.a
            href: t.mustacheVar('orgUrl')
            class: t.classify
              'select-org-to-upgrade-list-item-link': true
              'js-select-org': !t.mustacheVar('isDisabled')
              'disabled js-disabled': t.mustacheVar('isDisabled')
          , ->

            t.mustacheBlock 'logoHash', ->
              t.img '.select-org-to-upgrade-list-item-link-image', { src: t.mustacheVar('__logoDomain') + '/' + t.mustacheVar('logoHash') + '/30.png', alt: t.mustacheVar('displayName') + " logo" }

            t.mustacheBlockInverted 'logoHash', ->
              t.span '.icon-lg.icon-organization.select-org-to-upgrade-list-item-link-image'

            t.span '.select-org-to-upgrade-list-item-link-name', ->
              t.text t.mustacheVar('displayName')

            t.span '.select-org-to-upgrade-list-item-link-details.quiet', ->
              t.text localizeCount('members', t.mustacheVar('memberCount'))
              t.text '. '
              t.mustacheBlock 'isPremium', ->
                t.mustacheBlockInverted 'needsBCUpgrade', ->
                  t.format 'this-organization-already-has-business-class'

                t.mustacheBlockInverted 'isBC2PO', ->
                  t.mustacheBlock 'needsBCUpgrade', ->
                    t.mustacheBlock 'isAdmin', ->
                      t.format 'an-update-is-available'
                    t.mustacheBlockInverted 'isAdmin', ->
                      t.format 'an-update-is-available-you-need-to-be-an-admin-to-upgrade'

                t.mustacheBlock 'isBC2PO', ->
                  t.format 'legacy-business-class-contact-account-manager'

    t.mustacheBlockInverted 'orgs', ->
      t.p { style: 'margin: 24px 0;' }, ->
        t.format 'you-don-t-have-any-organizations'
        t.raw ' '
        t.a '.js-create-org', { href: '#' }, ->
          t.format 'click-here-to-create-one'
